import { useEffect, useState } from "react";

type NetworkInformation = {
  type?: string;
  effectiveType?: string;
  saveData?: boolean;
  addEventListener?: (event: "change", listener: () => void) => void;
  removeEventListener?: (event: "change", listener: () => void) => void;
};

function getConnection(): NetworkInformation | undefined {
  if (typeof navigator === "undefined") return undefined;
  const nav = navigator as Navigator & { connection?: NetworkInformation };
  return nav.connection;
}

function computeAllowed(): boolean {
  const conn = getConnection();
  if (!conn) return true;
  if (conn.saveData) return false;
  switch (conn.type) {
    case "wifi":
    case "ethernet":
    case "unknown":
      return true;
    case "cellular":
    case "bluetooth":
    case "wimax":
    case "none":
      return false;
    default:
      return conn.effectiveType === "4g";
  }
}

export function useAutoplayAllowed(): boolean {
  const [allowed, setAllowed] = useState<boolean>(() => computeAllowed());

  useEffect(() => {
    const conn = getConnection();
    if (!conn?.addEventListener) return;
    const onChange = () => setAllowed(computeAllowed());
    conn.addEventListener("change", onChange);
    return () => conn.removeEventListener?.("change", onChange);
  }, []);

  return allowed;
}
